/*!
 * Conversioni Google Ads (tag AW-621652208, caricato da GTM).
 * window.gtag e' definito da consent-init.js: Consent Mode v2 gestisce il consenso,
 * quindi qui non serve alcun controllo aggiuntivo sul banner cookie.
 */
const ADS_ID = "AW-621652208";

export const ADS_LABELS = {
  contatto: "T02lCO6ujZEdEPDRtqgC",
  acquistoProdotto: "C5PBCNOhiOccEPDRtqgC",
  abbonamentoForfettari: "ecLYCPGujZEdEPDRtqgC",
};

const STUDIO_EMAILS = ["assistenza@casalisilvia.com", "casali.silvia@gmail.com"];
const STUDIO_NAMES = ["sc dottori commercialisti", "silvia casali dottori commercialisti"];

/** Stesse regole di esclusione usate dalle statistiche del sito. */
export const isTestLead = (name = "", email = "") => {
  const n = String(name || "").toLowerCase();
  const e = String(email || "").toLowerCase().trim();
  if (n.includes("test") || n.includes("prova") || e.includes("test") || e.includes("prova")) return true;
  if (e.endsWith("@example.com") || e.endsWith("@esempio.it")) return true;
  if (STUDIO_EMAILS.includes(e)) return true;
  if (STUDIO_NAMES.some((s) => n.includes(s))) return true;
  return false;
};

export const sendAdsConversion = (label, params = {}) => {
  if (typeof window.gtag !== "function") return false;
  try {
    window.gtag("event", "conversion", {
      send_to: `${ADS_ID}/${label}`,
      currency: "EUR",
      ...params,
    });
    return true;
  } catch (e) {
    return false;
  }
};
